import type { ChangeEvent, ComponentType } from 'react';

import { FormControl, type IFormikFormControlProps } from './FormControl'
import { type IToggleProps, Toggle } from '../../elements/Toggle/'

interface IFormToggleProps
  extends Pick<
      IFormikFormControlProps,
      Exclude<keyof IFormikFormControlProps, 'children'>
    >,
    IToggleProps {
  id: string
  name: string
}
export const createOnChangeHandler =
  (handleChange: any) => (e: ChangeEvent<HTMLInputElement>) => {
    e.persist()
    handleChange(e.target.checked)
  }

export const FormToggle: ComponentType<IFormToggleProps> = (props) => {
  const {
    name,
    disabled,
    id,
    label,
    helperText,
    required,
    fullWidth,
    labelIcon,
    labelTooltipMessage,
    labelTooltipAriaLabel,
    onChange = () => undefined,
    ...ToggleProps
  } = props
  return (
    <FormControl
      name={name}
      disabled={disabled}
      id={id}
      label={label}
      labelIcon={labelIcon}
      labelTooltipMessage={labelTooltipMessage}
      labelTooltipAriaLabel={labelTooltipAriaLabel}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
    >
      {({ value, handleChange, isSubmitting }) => (
        <Toggle
          {...ToggleProps}
          id={id}
          disabled={isSubmitting || disabled}
          checked={value || false}
          onChange={createOnChangeHandler((e) => {
            handleChange(e)
            onChange(e, !value)
          })}
          value={id}
        />
      )}
    </FormControl>
  )
}
FormToggle.displayName = 'Form.Toggle'
